"use strict";
const warn = console.warn;
console.warn = function (...args) {
    const message = (args[0] || '').toString();
    if (message.startsWith('[Vue warn]:')) {
        if (message.includes('(deprecation')
            || message.includes('Plugin has already been applied to target app.')
            || message.includes('has already been registered in target app.')) {
            return;
        }
    }
    return warn.apply(console, args);
};
//# sourceMappingURL=index.js.map